import SupplierConfirmationLinesApi from '../../../../../api/SupplierConfirmationLinesApi';
import _ from 'lodash';

export function getList() {
   return SupplierConfirmationLinesApi.getList()
      .then(response => {
         if (response.data.success === true) {
            response.data.data.forEach(el => {
               el.key = el.id;
            });
            return response.data;
         }
         else
            throw new Error(response.data.error ? response.data.error : 'Server error');
      })
      .catch(error => {
         throw error;
      });
}

export function getListExtended(confirmationId, params = [], filterValues = {}) {
   return SupplierConfirmationLinesApi.getListExtended(confirmationId, params, filterValues)
      .then(response => {
         if (response.data.success === true) {
            response.data.data.data.forEach(el => {
               el.key = el.id;
            });
            // console.log(response);
            return response.data;
         }
         else
            throw new Error(response.data.error ? response.data.error : 'Server error');
      })
      .catch(error => {
         throw error;
      });
}

export function getModel() {
   return SupplierConfirmationLinesApi.getModel()
      .then(response => {
         if (response.data.success === true) {
            return response.data;
         }
         else
            throw new Error(response.data.error ? response.data.error : 'Server error');
      })
      .catch(error => {
         throw error;
      });
}
export function getItem(itemId, params = [], filterValues = {}) {
   return SupplierConfirmationLinesApi.getItem(itemId, params, filterValues)
      .then(response => {
         if (response.data.success === true) {
            // console.log(response);
            return response.data;
         }
         else
            throw new Error(response.data.error ? response.data.error : 'Server error');
      })
      .catch(error => {
         throw error;
      });
}

export function importFromFile(formData) {
   return SupplierConfirmationLinesApi.importFromFile(formData)
      .then(response => {
         if (response.data.success === true) {
            return response.data;
         }
         else {
            throw new Error(response.data.error ? response.data.error : 'Server error');
         }
      })
      .catch(error => {
         throw error;
      });
}